export default __webpack_public_path__ + "static/media/McMaster-gray.77b346ca.png";